export const DemoBadge = ({ show = true, className = "" }) => {
  if (!show) return null;
  return (
    <span
      data-testid="demo-badge"
      className={`inline-block bg-[#FF2E63]/15 text-[#FF2E63] text-[10px] uppercase tracking-[0.2em] px-2 py-1 border border-[#FF2E63]/30 ${className}`}
    >
      Démo
    </span>
  );
};

export default DemoBadge;
